import _ from 'lodash';

import { PaymentMethodType } from '@/modules/user/user.types';

import {
  PaymentAddressPayload,
  PaymentDetailsPayload,
  PaymentDetailsTransfers,
  PaymentDetailsTransfersPayload,
} from '../../TransactionDetails.types';
import { CheckStatus } from '../constants';

export const formatPaymentAddress = (address?: PaymentAddressPayload) => ({
  id: _.toString(address?.id),
  line1: address?.line1,
  line2: address?.line2,
  line3: address?.line3,
  line4: address?.line4,
  city: address?.city,
  ...(address?.state
    ? {
        state: {
          id: _.toString(address?.state?.id),
          code: address?.state?.code,
          name: address?.state?.name,
        },
      }
    : {}),
  ...(address?.country
    ? {
        country: {
          id: _.toString(address?.country?.id),
          alpha2: address?.country?.alpha2,
          alpha3: address?.country?.alpha3,
          usPostal: address?.country?.us_postal,
          name: address?.country?.name,
        },
      }
    : {}),
  zipcode: address?.zipcode,
  validated: address?.validated,
});

export const getPaymentAddress = (data?: PaymentDetailsPayload, transfer?: PaymentDetailsTransfersPayload) => {
  if (
    transfer?.payment_method_type === PaymentMethodType.CHECK &&
    transfer?.payment_status === CheckStatus.PENDING
  ) {
    return formatPaymentAddress(data?.payment_address);
  }
  return formatPaymentAddress(transfer?.payment_address_response_dto);
};

export const getFormattedData = (data?: PaymentDetailsPayload): PaymentDetailsTransfers[] | undefined =>
  data?.transfers
    ?.sort((a, b) => (a?.payment_id || 0) - (b?.payment_id || 0))
    ?.map((transfer) => ({
      id: _.uniqueId(),
      paymentType: data?.payment_type,
      payTo: data?.pay_to,
      verificationStatus: data?.verification_status,
      accountId: _.toString(data?.account_id),

      amount: transfer.amount,
      paymentStatus: transfer?.payment_status,
      paymentNumber: transfer?.payment_number,
      paymentId: _.toString(transfer?.payment_id),
      transactionDate: transfer?.transaction_date,
      mailingDate: transfer?.mailing_date,
      accountNumberLast4: transfer?.account_number_last4,
      invoiceId: _.toString(transfer?.invoice_id),
      invoiceType: transfer?.invoice_type,
      traceId: _.toString(transfer?.trace_id),
      paymentDate: transfer?.payment_date,
      paymentDocumentPath: transfer?.payment_document_path,
      ...(transfer?.requisites
        ? {
            requisites: {
              phoneNumber: transfer?.requisites?.phone_number,
              email: transfer?.requisites?.email,
              cardHolderName: transfer?.requisites?.card_holder_name,
              cardLast4: transfer?.requisites?.card_last4,
              cardExpirationDate: transfer?.requisites?.card_expiration_date,
              cardToken: transfer?.requisites?.card_token,
              cardType: transfer?.requisites?.card_type,
              accountNumberLength: transfer?.requisites?.account_number_length,
              accountDescription: transfer?.requisites?.account_description,
              accountNumberLast4: transfer?.requisites?.account_number_last4,
            },
          }
        : {}),
      paymentMethodType: transfer?.payment_method_type,
      paymentAddress: getPaymentAddress(data, transfer),
    }));

export const getDirectDepositInfo = (data?: PaymentDetailsPayload) => {
  if (data?.payment_method_type === PaymentMethodType.DIRECT_DEPOSIT) {
    return {
      status: data?.verification_status,
      accountId: data?.account_id ? _.toString(data?.account_id) : undefined,
    };
  }
  return undefined;
};
